import React from 'react';
import { Amplify } from 'aws-amplify';
import ChatInterface from './components/ChatInterface';
import './App.css';
import awsExports from './aws-exports';

// Configure Amplify with your config

Amplify.configure(awsExports);

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Archeage Chat</h1>
      </header>
      <ChatInterface />
    </div>
  );
}

export default App;
